/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'../../../api/DashboardAPI',
	'./api/EventGroupsAPI',
	'../../../lib/@waca/dashboard-common/dist/utils/ContentUtil',
	'../../../app/nls/StringResources'
], function (_, APIFactory,
	ContentActionsProviderAPI,
	DashboardAPI,
	EventGroupsAPI,
	ContentUtil,
	stringResources) {

	class EventGroupsActionProvider {
		constructor({ features }) {
			this._features = features;

			this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			features.ContentActions.registerProvider('EventGroups', this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		/**
		 * @implements ContentActionProviderAPI#getContentActionList
		 */
		getContentActionList() {
			const uiState = this._features['DashboardState'].getUiState();
			if (uiState.authoring === false) {
				return [];
			}

			return [{
				name: 'EventGroups',
				type: 'ToggleButton',
				baseClass: 'toolbar',
				section: ContentActionsProviderAPI.ACTION_SECTION.DASHBOARD,
				order: 30,
				checked: uiState.eventGroups,
				disabled: uiState.focus,
				label: stringResources.get('eventGroupButtonLabel'),
				icon: this._features['Icons'].getIcon('connect').id,
				action: () => this._features['DashboardState'].setEventGroups(true),
				offAction: () => this._features['DashboardState'].setEventGroups(false)
			}];
		}
	}

	return EventGroupsActionProvider;
});
